import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CartBaseCoreModule, CartPageEventModule } from '@spartacus/cart/base/core';
import { CartBaseOccModule } from '@spartacus/cart/base/occ';
import { WishListModule } from '@spartacus/cart/wish-list';
import {
  AnonymousConsentsModule,
  AuthModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  ProductModule,
  ProductOccModule,
  UserModule,
  UserOccModule,
  provideFeatureTogglesFactory,
} from '@spartacus/core';
import { OrderOccModule } from '@spartacus/order/occ';
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  // BannerModule,
  BreadcrumbModule,
  // CartComponentModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  // LinkModule,
  LoginRouteModule,
  LogoutModule,
  MyAccountV2Module,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PDFModule,
  PageTitleModule,
  PaymentMethodsModule,
  // ProductCarouselModule,
  ProductDetailsPageModule,
  ProductImagesModule,
  ProductIntroModule,
  ProductListModule,
  ProductListingPageModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductSummaryModule,
  ProductTabsModule,
  ScrollToTopModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  StockNotificationModule,
  TabParagraphContainerModule,
  VideoModule,
} from '@spartacus/storefront';
import { AddressBookModule } from '@spartacus/user/profile/components';
import { ExtendCheckoutOccModule } from '../core/occ/adapters/checkout/checkout-occ.module';
import { AsmCustomer360FeatureModule } from './features/asm/asm-customer360-feature.module';
import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { AsmModule } from './features/asm/asm.module';
import { BannerModule } from './features/banner/banner.module';
import { BreadcrumbsModule } from './features/breadcrumbs/breadcrumbs.module';
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module';
import { CartImportExportFeatureModule } from './features/cart/cart-import-export-feature.module';
import { CartQuickOrderFeatureModule } from './features/cart/cart-quick-order-feature.module';
import { CartSavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module';
import { CartComponentModule } from './features/cart/cart.module';
import { OrderFormModule } from './features/cart/order-form/order-form.module';
import { QuickOrderModule } from './features/cart/quick-order/quick-order.module';
import { WishListFeatureModule } from './features/cart/wish-list-feature.module';
import { ShimanoCheckoutModule } from './features/checkout/shimano-checkout.module';
import { CmsImageModule } from './features/cms-image/cms-image.module';
import { CookieConsentUserModule } from './features/cookie/cookie-consent-user/cookie-consent-user.module';
import { CookieProductCaptureModule } from './features/cookie/cookie-product-capture/cookie-product-capture.module';
import { CustomerServiceBannerModule } from './features/customer-service/customer-service-banner/customer-service-banner.module';
import { CustomerServiceSectionModule } from './features/customer-service/customer-service-section/customer-service-section.module';
import { CustomerTicketingFeatureModule } from './features/customer-ticketing/customer-ticketing-feature.module';
import { DealerSelectionListModule } from './features/dealer-selection-list/dealer-selection-list.module';
import { DigitalPaymentsFeatureModule } from './features/digital-payments/digital-payments-feature.module';
import { DownloadsModule } from './features/downloads/downloads.module';
import { EpdVisualizationFeatureModule } from './features/epd-visualization/epd-visualization-feature.module';
import { FooterModule } from './features/footer/footer.module';
import { CategoryNavModule } from './features/header/category-nav/category-nav.module';
import { HeaderLinksModule } from './features/header/header-links/header-links.module';
import { LanguageFlagModule } from './features/header/language-flag/language-flag.module';
import { MiniCartModule } from './features/header/mini-cart/mini-cart.module';
import { MyAccountModule } from './features/header/my-account/my-account.module';
import { ShimanoSearchBoxModule } from './features/header/search-box/search-box.module';
import { SiteLogoModule } from './features/header/site-logo/site-logo.module';
import { SrpToggleModule } from './features/header/srp-toggle/srp-toggle.module';
import { HighlightedProductModule } from './features/highlighted-product/highlighted-product.module';
import { ImportCsvModule } from './features/import-csv/import-csv.module';
import { ShimanoLinkModule } from './features/link/link.module';
import { AddEmployeeModule } from './features/myaccount/add-employee/add-employee.module';
import { DiscountsModule } from './features/myaccount/discounts/discounts.module';
import { EditEmployeeModule } from './features/myaccount/edit-employee/edit-employee.module';
import { MyaccountAccountInfoModule } from './features/myaccount/myaccount-account-info/myaccount-account-info.module';
import { MyaccountEditPreferencesModule } from './features/myaccount/myaccount-edit-preferences/myaccount-edit-preferences.module';
import { MyaccountEmployeeListsModule } from './features/myaccount/myaccount-employee-lists/myaccount-employee-lists.module';
import { MyaccountPaymentDetailsModule } from './features/myaccount/myaccount-payment-details/myaccount-payment-details.module';
import { MyaccountPersonalInfoModule } from './features/myaccount/myaccount-personal-info/myaccount-personal-info.module';
import { MyaccountPersonalinfoAddressModule } from './features/myaccount/myaccount-personalinfo-address/myaccount-personalinfo-address.module';
import { MyaccountYourCredentialsModule } from './features/myaccount/myaccount-your-credentials/myaccount-your-credentials.module';
import { OrderDetailsModule } from './features/myaccount/order-details/order-details.module';
import { NewsArticleModule } from './features/news/news-article/news-article.module';
import { NewsCategoryModule } from './features/news/news-category/news-category.module';
import { NewsListModule } from './features/news/news-list/news-list.module';
import { NotFoundModule } from './features/not-found/not-found.module';
import { OrderConfirmationModule } from './features/order-confirmation/order-confirmation.module';
import { OrderHistoryModule } from './features/order/order-history/order-history.module';
import { OrderFeatureModule } from './features/order4/order-feature.module';
import { ParagraphModule } from './features/paragraph/paragraph.module';
import { ShimanoPaymentModule } from './features/payment/shimano-payment.module';
import { PdfinvoicesModuleFeatureModule } from './features/pdf-invoices/pdfinvoices-module-feature.module';
import { ProductCarouselModule } from './features/product-carousel/product-carousel.module';
import { ProductConfiguratorFeatureModule } from './features/product-configurator/product-configurator-feature.module';
import { AlternativeProductsModule } from './features/product/alternative-products/alternative-products.module';
import { ProductDescriptionClassificationModule } from './features/product/product-description-classification/product-description-classification.module';
import { ProductImageModalModule } from './features/product/product-image-modal/product-image-modal.module';
import { ProductManualModule } from './features/product/product-manual/product-manual.module';
import { ProductPricingModule } from './features/product/product-pricing/product-pricing.module';
import { ProductPromotionsModule } from './features/product/product-promotions/product-promotions.module';
import { ProductReplacementModule } from './features/product/product-replacement/product-replacement.module';
import { ProductSearchEmptyModule } from './features/product/product-search-empty/product-search-empty.module';
import { ProductSizeChartModule } from './features/product/product-size-chart/product-size-chart.module';
import { ProductStockInfoModule } from './features/product/product-stock-info/product-stock-info.module';
import { ProductVariantsModule } from './features/product/product-variants/product-variants.module';
import { ShimanoProductImagesModule } from './features/product/shimano-product-images/shimano-product-images.module';
import { ShimanoProductListModule } from './features/product/shimano-product-list/shimano-product-list.module';
import { ShimanoProductReferencesModule } from './features/product/shimano-product-references/shimano-product-references.module';
import { ShimanoProductSummaryModule } from './features/product/shimano-product-summary/shimano-product-summary.module';
import { SpecTableModule } from './features/product/spec-table/spec-table.module';
import { PromotionalTextModule } from './features/promotional-text/promotional-text.module';
import { QualtricsFeatureModule } from './features/qualtrics/qualtrics-feature.module';
import { QualtricsModule } from './features/qualtrics/qualtrics-module/qualtrics-module.module'; // TODO: Qualtrics
import { RequestedDeliveryDateModuleFeatureModule } from './features/requested-delivery-date/requested-delivery-date-module-feature.module';
import { ResponsiveBannerModule } from './features/responsive-banner/responsive-banner.module';
import { SearchResultsModule } from './features/search-results/search-results.module';
import { SegmentRefsFeatureModule } from './features/segment-refs/segment-refs-feature.module';
import { ShimanoExplodedViewModule } from './features/shimano-exploded-view/shimano-exploded-view.module';
import { ShimanoImageZoomModule } from './features/shimano-image-zoom/shimano-image-zoom.module';
import { ShimanoTimestampedModule } from './features/shimano-timestamped/shimano-timestamped.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { SpecialOfferModule } from './features/special-offer/special-offer.module';
import { StoreFinderFeatureModule } from './features/storefinder/store-finder-feature.module';
import { TcAcceptanceModule } from './features/terms-and-conditions/tc-acceptance/tc-acceptance.module';
import { TermsAndConditionsModule } from './features/terms-and-conditions/terms-and-conditions.module';
import { TooltipTextModule } from './features/tooltip-text/tooltip-text.module';
import { PersonalizationFeatureModule } from './features/tracking/personalization-feature.module';
import { TagManagementFeatureModule } from './features/tracking/tag-management-feature.module';
import { UnitSelectionListModule } from './features/unit-selection-list/unit-selection-list.module';
import { ChangePasswordModule } from './features/user/change-password/change-password.module';
import { ForgotPasswordModule } from './features/user/forgot-password/forgot-password.module';
import { LoginFooterModule } from './features/user/login-footer/login-footer.module';
import { LoginModule } from './features/user/login/login.module';
import { RequestAccountModule } from './features/user/request-account/request-account.module';
import { ResetPasswordModule } from './features/user/reset-password/reset-password.module';
import { UserFeatureModule } from './features/user4/user-feature.module';
import { WarrantyModule } from './features/warranty/warranty.module';

@NgModule({
  declarations: [],
  imports: [
    // Auth Core
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    // Basic Cms Components
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BreadcrumbModule,
    // BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    // User Core,
    UserOccModule,
    UserModule,
    // User UI,
    AddressBookModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    // Anonymous Consents Core,
    AnonymousConsentsModule.forRoot(),
    // Anonymous Consents UI,
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    // Product Core,
    ProductModule.forRoot(),
    ProductOccModule,
    // Product UI,
    ProductDetailsPageModule,
    ProductListingPageModule,
    // ProductListModule,
    SearchBoxModule,
    // ProductFacetNavigationModule,
    ProductTabsModule,
    // ProductCarouselModule,
    // ProductReferencesModule,
    ProductImagesModule,
    // ProductSummaryModule,
    ProductIntroModule,
    // Cart Core,
    CartBaseCoreModule,
    CartBaseOccModule,
    // Cart UI,
    // CartComponentModule,
    WishListModule,
    CostCenterOccModule,
    // Order,
    OrderOccModule,
    // Page Events,
    NavigationEventModule,
    HomePageEventModule,
    CartPageEventModule,
    ProductPageEventModule,
    // External routes,
    ExternalRoutesModule.forRoot(),
    UserFeatureModule,
    PersonalizationFeatureModule,
    StoreFinderFeatureModule,
    SmartEditFeatureModule,
    // ProductVariantsFeatureModule,
    // ProductImageZoomFeatureModule,
    OrderFeatureModule,
    CartSavedCartFeatureModule,
    CartQuickOrderFeatureModule,
    CartImportExportFeatureModule,
    // Shimano Modules
    CommonModule,
    HeaderLinksModule,
    MyAccountModule,
    MiniCartModule,
    SiteLogoModule,
    ShimanoSearchBoxModule,
    LanguageFlagModule,
    SrpToggleModule,
    TermsAndConditionsModule,
    CategoryNavModule,
    BannerModule,
    FooterModule,
    ParagraphModule,
    WarrantyModule,
    NotFoundModule,
    ResponsiveBannerModule,
    LoginModule,
    LoginFooterModule,
    RequestAccountModule,
    ForgotPasswordModule,
    ResetPasswordModule,
    ChangePasswordModule,
    ShimanoLinkModule,
    AsmModule,
    ShimanoTimestampedModule,
    BreadcrumbsModule,
    DownloadsModule,
    TcAcceptanceModule,
    CustomerServiceSectionModule,
    CustomerServiceBannerModule,
    TooltipTextModule,
    MyaccountAccountInfoModule,
    MyaccountPaymentDetailsModule,
    MyaccountYourCredentialsModule,
    MyaccountEmployeeListsModule,
    AddEmployeeModule,
    NewsListModule,
    NewsArticleModule,
    NewsCategoryModule,
    SpecialOfferModule,
    EditEmployeeModule,
    DiscountsModule,
    MyaccountEditPreferencesModule,
    MyaccountPersonalinfoAddressModule,
    MyaccountPersonalInfoModule,
    HighlightedProductModule,
    OrderHistoryModule,
    OrderDetailsModule,
    ShimanoProductSummaryModule,
    AlternativeProductsModule,
    ProductDescriptionClassificationModule,
    ProductManualModule,
    ProductCarouselModule,
    ProductStockInfoModule,
    ProductSizeChartModule,
    ShimanoExplodedViewModule,
    QuickOrderModule,
    OrderFormModule,
    ProductPricingModule,
    ShimanoProductImagesModule,
    CartComponentModule,
    ImportCsvModule,
    ProductVariantsModule,
    ShimanoProductReferencesModule,
    ShimanoCheckoutModule,
    OrderConfirmationModule,
    ShimanoImageZoomModule,
    ProductReplacementModule,
    ShimanoProductListModule,
    SearchResultsModule,
    DealerSelectionListModule,
    ProductPromotionsModule,
    ProductSearchEmptyModule,
    CookieProductCaptureModule,
    CookieConsentUserModule,
    CmsImageModule,
    ExtendCheckoutOccModule,
    PromotionalTextModule,
    ScrollToTopModule,
    PageTitleModule,
    VideoModule,
    PDFModule,
    MyAccountV2Module,
    ProductListModule,
    ProductReferencesModule,
    ProductSummaryModule,
    AsmFeatureModule,
    AsmCustomer360FeatureModule,
    WishListFeatureModule,
    DigitalPaymentsFeatureModule,
    EpdVisualizationFeatureModule,
    ProductConfiguratorFeatureModule,
    PdfinvoicesModuleFeatureModule,
    QualtricsFeatureModule,
    RequestedDeliveryDateModuleFeatureModule,
    SegmentRefsFeatureModule,
    TagManagementFeatureModule,
    CustomerTicketingFeatureModule,
    CartBaseFeatureModule,
    UnitSelectionListModule,
    ProductImageModalModule,
    SpecTableModule,
    ShimanoPaymentModule,
    QualtricsModule,
  ],
  providers: [
    provideFeatureTogglesFactory(() => {
      const appFeatureToggles: Required<any> = {
        a11yImproveContrast: false,
      };
      return appFeatureToggles;
    }),
  ],
})
export class SpartacusFeaturesModule {}
